import { ImageModel, ImageVariantModel, ImageVariantsModel } from '@loavies/c2c-models'

/**
 * @param {Object} image
 * @returns {loavies.models.image.ImageModel}
 */
export function mapImage(image) {
  return new ImageModel({
    id: image.id.uuid,
    variants: mapImageVariants(image.attributes.variants),
  })
}

/**
 * @param {Object} variants
 * @returns {loavies.models.image.ImageVariantsModel}
 */
export function mapImageVariants(variants) {
  return new ImageVariantsModel({
    original: mapImageVariant(variants.default),
    w200: mapImageVariant(variants['200']),
    w400: mapImageVariant(variants['400']),
    w600: mapImageVariant(variants['600']),
    w900: mapImageVariant(variants['900']),
    w1000: mapImageVariant(variants['1000']),
  })
}

/**
 * @param {Object} variant
 * @returns {loavies.models.image.ImageVariantModel}
 */
export function mapImageVariant(variant) {
  return new ImageVariantModel({
    url: variant.url,
    width: variant.width,
    height: variant.height,
  })
}
